import { createAction, createSlice } from '@reduxjs/toolkit';

import { ACCESS_TOKEN_KEY , IS_ADMIN} from '../../constants';
import { api } from '../../api';

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    loggedIn: null,
    loggingIn: 0,
    error: null,
    success: null
  },
  reducers: {
    setLoggedIn(state, action) {
      state.loggedIn = action.payload;
    },
    loginStart(state) {
      state.loggingIn = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      state.loggingIn = false;
      state.loggedIn = true;
    },
    loginFailed(state, action) {
      state.loggingIn = false;
      state.error = action.payload;
    },
    registerSuccess(state, action) {
      state.loggingIn = false;
      state.success = action.payload;
    },
    forgetPasswordSuccess(state, action) {
      state.loggingIn = false;
      state.success = action.payload;
    },
    setError(state, action) {
      state.error = null;
    }
  },
});

export const { setLoggedIn, loginStart, loginSuccess, loginFailed, registerSuccess, forgetPasswordSuccess,setError} = authSlice.actions;

export default authSlice.reducer;

export const selectLoggedIn = state => state.auth.loggedIn;
export const selectLoggingIn = state => state.auth.loggingIn;
export const selectError = state => state.auth.error;
export const selectSuccess = state => state.auth.success;

export const init = () => async dispatch => {
  dispatch(setLoggedIn(!!localStorage.getItem(ACCESS_TOKEN_KEY)));
};

export const logIn = (email, password) => async dispatch => {
  dispatch(loginStart());
  try {
    const { access_token: token, isAdmin} = await api('/api/login_new', {
      email,
      password,
    }, false);
   
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
    localStorage.setItem(IS_ADMIN, isAdmin);
    dispatch(loginSuccess());
  } catch (err) {
    dispatch(loginFailed(err.message));
  }
};

export const register = (email, password, first_name, last_name) => async dispatch => {
  dispatch(loginStart());
  try {
    const { message } = await api('/api/register_new', {
      email,
      password,
      first_name,
      last_name,
    }, false);
    
    // localStorage.setItem(ACCESS_TOKEN_KEY, token);
    // localStorage.setItem(IS_ADMIN, isAdmin);
    dispatch(registerSuccess(message));
  } catch (err) {
    dispatch(loginFailed(err.message));
  }
};

export const reset = createAction('reset');

export const logOut = () => async dispatch => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  dispatch(reset());
  dispatch(init());
};


export const resetPassoword = (email) => async dispatch => {
  dispatch(loginStart());
  try {
    const {message  }= await api('/api/reset_password_request', {
      email,
    }, false);

    dispatch(forgetPasswordSuccess(message));
  } catch (err) {
    dispatch(loginFailed(err.message));
  }
};

export const resetError = () => async dispatch => {
  dispatch(setError());
};